import { FC } from "react";

import { Box } from "@mui/material";
import { FieldValues, Path, useFormContext } from "react-hook-form";

import { useFormV2Context } from "../../../contexts/FormV2Context";
import { buildCommunicationPreferenceDefaults } from "../../../helpers/communicationPreferenceDefaults";

import { CommunicationPreferencesField } from "./CommunicationPreferencesField";

export const COMMUNICATION_PREFERENCES_FIELD_NAME = "communicationPreferencesSelected";
const COMMUNICATION_PREFERENCES_INTERACTED_FIELD_NAME = "communicationPreferencesInteracted";
export const COMMUNICATION_PREFERENCES_FIELD_ID = "communication-preferences-field";

// Not an entry in customAnswersOfOrder: those slots are dense and index-mapped, and a preference is not an answer.
// The opt-out default is seeded by each provider's defaultValues, so there is nothing to initialise here.
export const CommunicationPreferencesFieldContainer: FC = () => {
  const { communicationPreferences, formCountry, isPreview } = useFormV2Context();
  const form = useFormContext<FieldValues>();

  const name = COMMUNICATION_PREFERENCES_FIELD_NAME as Path<FieldValues>;
  const interactedName = COMMUNICATION_PREFERENCES_INTERACTED_FIELD_NAME as Path<FieldValues>;
  const selectedValue: string[] = form.watch(name) ?? [];
  // Preview options change after mount, so derive the ticks instead of reading form state.
  const value = isPreview
    ? buildCommunicationPreferenceDefaults(communicationPreferences, formCountry).communicationPreferencesSelected
    : selectedValue;

  if (communicationPreferences.length === 0) {
    return null;
  }

  return (
    // Matches the marginTop every QuestionField gets in BuyerQuestionsSection.
    <Box sx={{ marginTop: 1.5 }} id={COMMUNICATION_PREFERENCES_FIELD_ID}>
      <CommunicationPreferencesField
        value={value}
        onChange={(contactListIds) => {
          form.setValue(interactedName, true, { shouldDirty: true });
          form.setValue(name, contactListIds, { shouldDirty: true });
        }}
      />
    </Box>
  );
};
